/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { safeRest } from '../../utils/functions.js';
import { HEADER_LEVEL, FONT_SIZE } from './constants.js';
import { CardHeaderWrapper } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["headerLevel", "withAdornment", "adornmentColor", "fontSize", "centered", "children"];
var CardHeader = function CardHeader(_ref) {
  var _ref$headerLevel = _ref.headerLevel,
    headerLevel = _ref$headerLevel === undefined ? HEADER_LEVEL.NONE : _ref$headerLevel,
    _ref$withAdornment = _ref.withAdornment,
    withAdornment = _ref$withAdornment === undefined ? false : _ref$withAdornment,
    _ref$adornmentColor = _ref.adornmentColor,
    adornmentColor = _ref$adornmentColor === undefined ? '' : _ref$adornmentColor,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === undefined ? FONT_SIZE.LARGE : _ref$fontSize,
    _ref$centered = _ref.centered,
    centered = _ref$centered === undefined ? false : _ref$centered,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var safeProps = safeRest(rest);
  return /*#__PURE__*/jsx(CardHeaderWrapper, _objectSpread(_objectSpread({
    role: headerLevel === HEADER_LEVEL.NONE ? undefined : 'heading',
    "aria-level": headerLevel === HEADER_LEVEL.NONE ? undefined : headerLevel,
    withAdornment: withAdornment,
    adornmentColor: adornmentColor,
    fontSize: fontSize,
    centered: centered,
    theme: theme
  }, safeProps), {}, {
    children: children
  }));
};
process.env.NODE_ENV !== "production" ? CardHeader.propTypes = {
  /** Add adornment */
  withAdornment: PropTypes.bool,
  /** Override adornment color */
  adornmentColor: PropTypes.string,
  /** Font size */
  fontSize: PropTypes.oneOf([FONT_SIZE.SMALL, FONT_SIZE.MEDIUM, FONT_SIZE.LARGE]),
  /** Force entire card to be centered */
  centered: PropTypes.bool,
  /** Card header content */
  children: PropTypes.node.isRequired,
  /** Header level */
  headerLevel: PropTypes.oneOf([HEADER_LEVEL.NONE, HEADER_LEVEL.H1, HEADER_LEVEL.H2, HEADER_LEVEL.H3, HEADER_LEVEL.H4, HEADER_LEVEL.H5, HEADER_LEVEL.H6])
} : undefined;
process.env.NODE_ENV !== "production" ? CardHeader.displayName = 'CardHeader' : undefined;

export { CardHeader as default };
